import { w as win } from "./common-namespaces-client-DXKc2YAH.mjs";
const otto = win.otto ?? {};
export {
  otto as o
};
/*🤫*/
